function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _filter;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  var _ref2, _ref3, _ref4;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logos:whatsapp-icon",
    clipPath: "url(#clip0_1354_9819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.640234 14.8205C0.639531 17.3411 1.30328 19.8022 2.56539 21.9715L0.519531 29.3834L8.16391 27.3946C10.2782 28.5367 12.6472 29.1351 15.0545 29.1353H15.0609C23.0079 29.1353 29.477 22.7186 29.4804 14.8318C29.482 11.01 27.9834 7.41631 25.2606 4.71258C22.5384 2.0091 18.9179 0.519444 15.0603 0.5177C7.11227 0.5177 0.643633 6.93398 0.640352 14.8205",
    fill: "url(#paint0_linear_1354_9819)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_i_1354_9819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.125391 14.8158C0.12457 17.4271 0.812109 19.9763 2.11922 22.2233L0 29.9008L7.91848 27.8407C10.1003 29.021 12.5568 29.6434 15.0564 29.6443H15.0628C23.295 29.6443 29.9965 22.9969 30 14.8277C30.0014 10.8686 28.4489 7.1457 25.6289 4.34512C22.8086 1.54488 19.0586 0.00162791 15.0628 0C6.82922 0 0.128672 6.64651 0.125391 14.8158ZM4.84102 21.8363L4.54535 21.3706C3.30246 19.4097 2.64645 17.1436 2.64738 14.8167C2.65008 8.02663 8.2193 2.50233 15.0675 2.50233C18.3839 2.50372 21.5006 3.78651 23.8448 6.11395C26.1889 8.44163 27.4788 11.5358 27.478 14.8267C27.475 21.6169 21.9056 27.1419 15.0628 27.1419H15.0579C12.8298 27.1407 10.6446 26.547 8.73891 25.425L8.28539 25.1581L3.58641 26.3806L4.84102 21.8362V21.8363Z",
    fill: "url(#paint1_linear_1354_9819)",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3295 8.62189C11.0499 8.00526 10.7557 7.99282 10.4898 7.982C10.272 7.9727 10.0231 7.9734 9.77446 7.9734C9.52556 7.9734 9.12114 8.06631 8.77931 8.43666C8.43712 8.80735 7.4729 9.70317 7.4729 11.5251C7.4729 13.3472 8.81036 15.1081 8.99681 15.3554C9.18349 15.6022 11.5788 19.4608 15.3724 20.9453C18.5252 22.1789 19.1668 21.9335 19.8511 21.8717C20.5354 21.81 22.0593 20.9761 22.3702 20.1113C22.6814 19.2467 22.6814 18.5055 22.5881 18.3506C22.4948 18.1963 22.2459 18.1036 21.8727 17.9185C21.4993 17.7333 19.6644 16.8374 19.3223 16.7137C18.9801 16.5903 18.7313 16.5286 18.4824 16.8994C18.2335 17.2697 17.5188 18.1036 17.3009 18.3506C17.0833 18.5982 16.8655 18.629 16.4924 18.4437C16.1189 18.2579 14.9169 17.8674 13.4908 16.6058C12.3813 15.6242 11.6322 14.412 11.4145 14.0412C11.1968 13.671 11.3912 13.4703 11.5783 13.2857C11.746 13.1198 11.9517 12.8533 12.1385 12.6371C12.3246 12.4208 12.3867 12.2665 12.5111 12.0196C12.6357 11.7724 12.5734 11.5561 12.4802 11.3708C12.3867 11.1856 11.6614 9.3541 11.3295 8.62189Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1354_9819",
    x: 0,
    y: 0,
    width: 30,
    height: 33.9008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1354_9819"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1354_9819",
    x1: 1448.56,
    y1: 2887.09,
    x2: 1448.56,
    y2: 0.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38",
    style: (_ref2 = {
      stopColor: "#1FAF38"
    }, _defineProperty(_ref2, "stopColor", "color(display-p3 0.1216 0.6863 0.2196)"), _defineProperty(_ref2, "stopOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669",
    style: (_ref3 = {
      stopColor: "#60D669"
    }, _defineProperty(_ref3, "stopColor", "color(display-p3 0.3765 0.8392 0.4118)"), _defineProperty(_ref3, "stopOpacity", 1), _ref3)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1354_9819",
    x1: 30,
    y1: 1.5,
    x2: -1,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    style: (_ref4 = {
      stopColor: "#D0D5DD"
    }, _defineProperty(_ref4, "stopColor", "color(display-p3 0.8157 0.8353 0.8667)"), _defineProperty(_ref4, "stopOpacity", 1), _ref4)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_9819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.25304a457b90b4332e0c6d9d732adf05.svg";
export { ForwardRef as ReactComponent };